module.exports = __webpack_public_path__ + "img/Aura_sleep.7b380b9c.png";